import React, { ReactElement } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/pro-solid-svg-icons';
import { StyledReactPhoneInput } from './styles';

export const PhoneInput = ({
  defaultCountry,
  placeHolder = 'Enter phone number',
  value,
  onChange,
}: {
  defaultCountry?: string | null;
  placeHolder?: string;
  value: string | undefined;
  onChange: (value: string | undefined) => void;
}): ReactElement => {
  return (
    <StyledReactPhoneInput
      defaultCountry={defaultCountry}
      countrySelectProps={{
        arrowComponent: () => (
          <FontAwesomeIcon
            className="PhoneInputCountryArrow"
            icon={faAngleDown}
          />
        ),
      }}
      placeholder={placeHolder}
      value={value}
      onChange={onChange}
    />
  );
};
